<template>
    <div class="main ">
        <div v-if="loading" class="text-center py-5">
      <p>Loading blog details...</p>
    </div>
    
    <div v-else-if="blogDetail" class="blog-detail-container container">
      <div class="row">
        <div class="col-12 mt-5">
          <h1 class="blog-detail__title mb-4">{{ blogDetail.bg_title }}</h1>
          
          <div v-if="blogDetail.bg_image_one" class="blog-detail__image mb-4">
            <!-- {{ IMAGEURL + blogDetail.bg_image_one }} -->
            <img 
              :src="`${IMAGEURL}${blogDetail.bg_image_one}`" 
              class="img-fluid w-100" 
              :alt="blogDetail.bg_title"
            />
            <!-- <img 
              src="@/assets/imgs/blogimg.jpg" 
              class="img-fluid w-100" 
              :alt="blogDetail.bg_title"
            /> -->
          </div>
          
          <div class="blog-detail__content">
            <!-- Render HTML content safely -->
            <div v-html="blogDetail.bg_body" class="blog-detail__body" ></div>
          </div>
          
          <div class="blog-detail__meta mt-4">
            <p v-if="blogDetail.created_at" class="text-muted">
              Published on: {{ blogDetail.created_at }}
            </p>

            <div class="d-flex">
              <div class="tags mr-2" v-for="tag in blogDetail.bg_tags.split(',')" >
              <span>{{ tag.trim() }}</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="text-center py-5">
      <p>Blog not found</p>
    </div>
    </div>
  </template>
  
  <script>
  import { IMAGEURL } from "@/config/index";
  import homeServices from "@/apiServices/homeServices";
  
  export default {
    name: 'BlogDetailPage',
    data() {
      return {
        IMAGEURL,
        blogDetail: null,
        loading: true,
        error: null
      }
    },
    methods: {
      async fetchBlogDetail() {
        try {
          // Get blog ID from route parameter
          const blogId = this.$route.params.id;
          
          // Fetch blog details
          const response = await homeServices.getSingleBlog({ bg_id: blogId });
          
          if (response.data.status) {
            console.log(response.data.data);
            this.blogDetail = response.data.data;

            const blogTitleSlug = this.createSlug(this.blogDetail.bg_title);
          this.$router.replace({ name: "BlogDetail", params: { id: blogId, title: blogTitleSlug } });
          } else {
            this.error = 'Unable to fetch blog details';
          }
        } catch (error) {
          console.error('Error fetching blog details:', error);
          this.error = 'An error occurred while fetching blog details';
        } finally {
          this.loading = false;
        }
      },
      
      
    },
    created() {
      // Fetch blog details when component is created
      this.fetchBlogDetail();
    }
  }
  </script>
  
  <style scoped>
  .main{
    min-height: 100vh;
    margin-top: 100px;
    
  }
  .blog-detail__title {
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
  }
  
  .blog-detail__image img {
    max-height: 500px;
    object-fit: cover;
    width: 100%;
  }
  
  .blog-detail__content {

    font-size: 1.1rem;
  }
  
  .blog-detail__meta {
    border-top: 1px solid #eee;
    padding-top: 1rem;
    display: flex;
    justify-content: space-between;
  }
  
  .tags span{
    background-color: #e8e4ec;
  padding: 10px 15px;
  font-weight: 600;
  text-transform: capitalize;
  font-size: 15px;
/* border-radius: 20px; */
color: rgb(49, 49, 49);
}

/* .blog-detail__body p{
  font-size: 30px !important;
} */

*{
  font-family: Arial, Helvetica, sans-serif;
}


  
  </style>


// WEBPACK FOOTER //
// src/components/pages/Blogs/BlogDetail.vue